import React from 'react';
import ReactDOM from 'react-dom';

import ReactDOMServer from 'react-dom/server'

import Checkout from './Components/checkout/components/Checkout'
import RoiCalculator from './Components/roi-calculator/RoiCalculator'

import './shims/servershims'

global['React'] = React
global['ReactDOM'] = ReactDOM
global['ReactDOMServer'] = ReactDOMServer

global['Checkout'] = Checkout
global['RoiCalculator'] = RoiCalculator


//import registerServiceWorker from './registerServiceWorker';

//registerServiceWorker();
    


// WEBPACK FOOTER //
// ./src/index.js